import { Container } from "@/components/pieces/bootstrap";
import { PUBLIC_CONTENT_MAX_WIDTH } from "@/css/constants";

export function MissionBar() {
  return (
    <div className="bg-blue-900">
      <Container maxWidth={PUBLIC_CONTENT_MAX_WIDTH}>
        <div className="mg:py-16 flex flex-col gap-6 py-12 lg:flex-row lg:gap-8 xl:gap-24 xl:py-20">
          <div className="font-serif text-4xl font-light text-blue-300 md:text-5xl/snug lg:text-6xl/snug">
            Our mission is to scale excellence
          </div>
          <div className="text-lg text-white md:text-xl lg:mt-5 lg:max-w-xl lg:text-2xl/normal">
            <p>Your people need effective development.</p>
            <p>Your business demands scalable solutions.</p>
            <p>
              Exec combines the precision and tirelessness of AI with the
              irreplaceable guidance of human expertise, to enable every
              employee to perform at their peak.
            </p>
            <p>
              Create the programs you've always envisioned, with white-glove
              support the whole way.
            </p>
            <p className="text-blue-300">
              Finally, talent development without tradeoffs.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}
